module.exports = __webpack_public_path__ + "img/bm5.82f96387.png";